class FaqBlock
{
	constructor(el: Element)
	{
		let groupedButtonsContainer = el.querySelector(".faq-block__grouped-buttons");
		let grouppedButtonItems = el.querySelectorAll<HTMLElement>(".faq-block__grouped-buttons__item");
		let faqLists = el.querySelectorAll<HTMLElement>(".faq-list");

		if (groupedButtonsContainer)
		{
			faqLists.forEach((faq, index) =>
			{
				if (index !== 0)
				{
					faq.classList.add("hidden");
					faq.setAttribute("aria-hidden", "true");
				}
			});

			grouppedButtonItems[0]?.classList.add("active");
			grouppedButtonItems[0]?.setAttribute("aria-hidden", "false");

			grouppedButtonItems.forEach(item =>
			{
				item.addEventListener("click", () =>
				{
					let groupName = item.dataset.groupName;

					grouppedButtonItems.forEach(item =>
					{
						if (item.dataset.groupName === groupName)
						{
							item.classList.add("active");
						}
						else
						{
							item.classList.remove("active");
						}
					})


					faqLists.forEach(faq =>
					{
						if (faq.dataset.groupName === groupName)
						{
							faq.classList.remove("hidden");
							faq.setAttribute("aria-hidden", "false");
						}
						else
						{
							faq.classList.add("hidden");
							faq.setAttribute("aria-hidden", "true");
						}
					});
				});
			});
		}
	}
}

document.querySelectorAll(".faq-block").forEach(el =>
{
	new FaqBlock(el);
});